const elements = document.querySelectorAll('.my-class');
export default elements.forEach(element => {
    if (element.classList.contains('active')) {
        // The element has the 'active' class applied
        console.log('This element is active:', element);
    } else {
        // The element does not have the 'active' class
        console.log('This element is not active:', element);
    }
});